const EXACT_APP_LABELS: Record<string, string> = {
  "/": "Dashboard",
  "/reporting": "Reporting",
  "/info": "Information",
  "/announcements": "Announcements",
  "/compliances/dashboard": "Compliance dashboard",
  "/compliances": "Compliance",
  "/standards": "Standards & references",
  "/compliance-status": "Compliance status",
  "/sla-tasks": "SLA Monitor",
  "/sla-workflows": "SLA Workflows",
  "/sla-workflows/create": "Add SLA Workflow",
  "/ticket": "Tickets",
  "/tickets": "Tickets",
  "/ticketsSupCompliance": "Tickets",
  "/organization-chart": "Organization chart",
  "/oneboxMessage": "Messages",
  "/catalogs": "Catalogs",
  "/catalogs/collection-sops": "Collection SOPs",
  "/catalogs/sop-masters": "SOP masters",
  "/data-inventory/dashboard": "Data inventory",
  "/QuestionControlTree": "Question control tree",
  "/control": "Control catalog",
  "/controls": "Control catalog",
  "/controls/create": "Create control",
  "/user": "User management",
  "/user/permissions": "User permissions",
  "/permission/groups": "Groups",
  "/permission": "Permissions",
  "/notification": "Notifications",
  "/team-onboarding": "Team onboarding",
  "/objective": "Objectives",
  "/surveys": "Surveys",
  "/bankQuestions": "Bank questions",
  "/frameWork": "Control landscape",
  "/assessment-score": "Assessment score",
  "/viewTaskCalender": "Task calendar",
  "/rcsa-compliance": "RCSA",
  "/impactarea": "Impact areas",
  "/create-survey": "Create survey",
  "/createQuestion": "Create question",
  "/certifications": "Certifications",
  "/assessment": "Assessment",
  "/workflows": "Workflows",
  "/documents": "Documents",
  "/documents/upload": "Upload document",
  "/documents/dashboard": "Documents dashboard",
  "/documents/notifications": "Document notifications",
  "/documents/structure": "Document structure",
  "/dataresource": "Data sources",
  "/guide": "User guide",
  "/demo-partners": "Demo partners",
  "/demo-partner/questionnaires": "Partner questionnaires",
  "/demo-partner/documents": "Partner documents",
  "/demo-partner/status": "Partner status",
  "/demo-partner/tickets": "Partner tickets",
  "/demo-partner/certifications": "Partner certifications",
  "/demo-partner/assessment-requests": "Assessment requests",
  "/demo-partner/profile": "Partner profile",
  "/demo-partner/visibility": "Partner visibility",
  "/function": "Functions",
  "/services": "Services",
  "/document-categories": "Document categories",
  "/configuration/dashboard": "Configuration dashboard",
  "/configuration/services-status": "Services status",
  "/configuration/lifecycle-stages": "Lifecycle stages",
  "/configuration/criticalities": "Criticalities",
  "/configuration/asset-types": "Asset types",
  "/configuration/asset-classifications": "Asset classifications",
  "/configuration/data-handled": "Data handled",
  "/configuration/references": "References",
  "/catalogs/services": "Services catalog",
  "/catalogs/services/create": "Create service",
  "/catalogs/resources": "Resources",
  "/catalogs/resources/create": "Create resource",
  "/policy": "Policy library",
  "/policy/categories": "Policy categories",
  "/policy/obligations": "Regulatory obligations",
  "/policy/approvals": "Policy approvals",
  "/policy/attestation": "Attestation",
  "/policy/versions": "Policy versions",
  "/policy/audit": "Policy audit log",
  "/audit/activity-log": "Activity log",
  "/policy/settings": "Policy settings",
  "/subBusinessUnit": "Sub-business unit",
  "/jobTitle": "Job title",
  "/createCurrency": "Currency",
  "/discoveredTypes": "Discovered types",
  "/rootCause": "Root cause",
  "/system": "System",
  "/subFunction": "Sub-function",
  "/activities": "Activities",
  "/riskCategory": "Risk category",
  "/controlReference": "Control reference",
  "/accountType": "Account type",
  "/eventType": "Event type",
  "/financialImpacts": "Financial impacts",
  "/createImpact": "Create impact",
  "/createsurvey": "Create survey",
  "/viewsurvey": "View survey",
  "/create": "Create",
  "/remediation": "Remediation",
  "/remediation/create": "Create remediation",
  // Financial Crime (src/pages/FinancialCrime)
  "/financial-crime": "Financial crime",
  "/financial-crime/search": "Search the lists",
  "/financial-crime/counterparties": "Counterparties",
  "/financial-crime/counterparties/new": "Register counterparty",
  "/financial-crime/alerts": "Screening alerts",
  "/financial-crime/tasks": "Analyst checks",
  "/financial-crime/approvals": "Screening approvals",
  "/financial-crime/settings": "Screening settings",
  "/financial-crime/risk-model": "Risk model",
};

const PREFIX_APP_LABELS_RAW: [string, string][] = [
  ["/user/activation", "User activation"],
  ["/compliances/view-control", "View control"],
  ["/compliances/edit", "Edit compliance"],
  ["/compliances/status", "Compliance status"],
  ["/compliances/dashboard", "Compliance dashboard"],
  ["/catalogs/services/create", "Service catalog"],
  ["/catalogs/resources/edit", "Edit resource"],
  ["/remediation/edit", "Edit remediation"],
  // /remediation/:id would otherwise fall through to humanizePathTail and show
  // the raw UUID in the breadcrumb (the title itself is set via
  // usePageHeadingOverride in RemediationDetail).
  ["/remediation", "Remediation"],
  ["/catalogs/resources/create", "Create resource"],
  // /sla-workflows/edit/:id would otherwise fall through to humanizePathTail and
  // show the raw UUID in the breadcrumb.
  ["/sla-workflows/edit", "Edit SLA Workflow"],
  ["/sla-workflows", "SLA Workflows"],
  ["/approvals", "Approval Workflow"],
  ["/controls/update", "Update control"],
  ["/updatecontrol", "Update control"],
  ["/documents", "Document details"],
  ["/documents/upload", "Upload document"],
  ["/documents/dashboard", "Documents dashboard"],
  ["/documents/notifications", "Notifications"],
  ["/documents/structure", "Document structure"],
  ["/dataresource/update", "Update data source"],
  ["/dataresource", "Data source"],
  ["/exportsurvey", "Export survey"],
  ["/export-survey", "Export survey"],
  ["/assessmentsurvey", "Assessment survey"],
  ["/assessment-survey", "Assessment survey"],
  ["/updatesurvey", "Update survey"],
  ["/updateSurvey", "Update survey"],
  ["/updateQuestion", "Update question"],
  ["/controls", "Control"],
  ["/updateImpacted", "Update impact"],
  ["/compliances", "Compliance"],
  ["/catalogs/resources", "Resources"],
  ["/catalogs/services", "Services catalog"],
  ["/catalogs", "Catalogs"],
  ["/configuration", "Configuration"],
  ["/demo-partner", "Partner"],
  ["/policy", "Policy"],
  ["/bankQuestions", "Bank questions"],
  // Financial Crime detail pages: /financial-crime/alerts/:id would otherwise show "Alerts".
  ["/financial-crime/counterparties", "Counterparty"],
  ["/financial-crime/alerts", "Screening alert"],
  ["/financial-crime/tasks", "Analyst check"],
  ["/financial-crime/lists", "Screening list"],
  ["/financial-crime/certificates", "Screening certificate"],
  ["/financial-crime", "Financial crime"],
];

const PREFIX_APP_LABELS: [string, string][] = [...PREFIX_APP_LABELS_RAW].sort(
  (a, b) => b[0].length - a[0].length
);

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function isRecordId(segment: string): boolean {
  return /^\d+$/.test(segment) || UUID_RE.test(segment) || /^[0-9a-f]{24}$/i.test(segment);
}

function titleCase(segment: string): string {
  return segment.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

function humanizePathTail(path: string): string {
  const segments = path.split("/").filter(Boolean);
  const segment = segments.pop() ?? "Page";
  // Raw record ids (numeric or UUID) are never a useful breadcrumb label — fall
  // back to the parent segment, or "Details" when there is nothing above it.
  if (isRecordId(segment)) {
    const parent = segments.pop();
    if (!parent || isRecordId(parent)) return "Details";
    return titleCase(parent);
  }
  return titleCase(segment);
}

export function breadcrumbPageLabel(pathname: string): string {
  const raw = pathname.replace(/\/$/, "") || "/";

  if (EXACT_APP_LABELS[raw]) return EXACT_APP_LABELS[raw];

  for (const [prefix, label] of PREFIX_APP_LABELS) {
    if (raw === prefix || raw.startsWith(`${prefix}/`)) {
      return label;
    }
  }

  return humanizePathTail(raw);
}

/** "Compliance dashboard" -> "complianceDashboard". Derived from the LABEL TEXT
 *  (not the path): EXACT_APP_LABELS and PREFIX_APP_LABELS_RAW both contain a
 *  handful of paths that collide once you strip the prefix vs. exact
 *  distinction (e.g. "/documents" is "Documents" as an exact match but
 *  "Document details" as a prefix fallback for "/documents/:id") - two
 *  different labels for the same path string. Keying off the label text
 *  instead means two different labels can never collide, and two entries that
 *  legitimately share the same English text (e.g. "/ticket"/"/tickets" both
 *  "Tickets") correctly share one translation instead of needing duplicates. */
function labelToI18nKey(label: string): string {
  const words = label.replace(/[^a-zA-Z0-9\s]/g, "").trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "page";
  return words
    .map((word, i) => {
      const lower = word.toLowerCase();
      return i === 0 ? lower : lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join("");
}

/**
 * i18n key suffix for the static breadcrumb/page-title label (`breadcrumbs.<key>`),
 * mirroring pageDescriptionI18nKey below. Empty string means there is no static
 * label for this path (it falls through to humanizePathTail's dynamic text,
 * which is not translatable via a static map) - callers should use
 * breadcrumbPageLabel's raw text directly in that case, untranslated.
 */
export function breadcrumbLabelI18nKey(pathname: string): string {
  const raw = pathname.replace(/\/$/, "") || "/";

  if (EXACT_APP_LABELS[raw]) return labelToI18nKey(EXACT_APP_LABELS[raw]);

  for (const [prefix, label] of PREFIX_APP_LABELS) {
    if (raw === prefix || raw.startsWith(`${prefix}/`)) {
      return labelToI18nKey(label);
    }
  }

  return "";
}

export function isBreadcrumbLandingPage(pathname: string): boolean {
  const raw = pathname.replace(/\/$/, "") || "/";
  return raw === "/";
}

/** Exact app paths → description key (omit to fall through to prefix / default). */
const EXACT_APP_PAGE_DESC_KEYS: Record<string, string> = {
  "/": "dashboardHome",
  "/controls": "controlCatalog",
  "/controls/create": "createControl",
  "/compliances/dashboard": "complianceModuleDashboard",
  "/standards": "standardsReferences",
  "/objective": "objectivesPage",
  "/audit/activity-log": "activityLogPage",
};

const PREFIX_APP_PAGE_DESC_KEYS_RAW: [string, string][] = [
  ["/compliances/view-control", "viewControl"],
  ["/compliances/edit", "editCompliance"],
  ["/compliances/status", "complianceStatus"],
  ["/compliances/dashboard", "complianceModuleDashboard"],
  ["/catalogs/services/create", "createService"],
  ["/catalogs/resources/edit", "editResource"],
  ["/catalogs/resources/create", "createResource"],
  ["/controls/update", "updateControl"],
  ["/updatecontrol", "updateControl"],
  ["/documents", "documents"],
  ["/documents/upload", "uploadDocument"],
  ["/documents/dashboard", "documentsDashboard"],
  ["/documents/notifications", "documentNotifications"],
  ["/documents/structure", "documentStructure"],
  ["/dataresource/update", "updateDataSource"],
  ["/dataresource", "dataSources"],
  ["/exportsurvey", "exportSurvey"],
  ["/export-survey", "exportSurvey"],
  ["/assessmentsurvey", "assessmentSurvey"],
  ["/assessment-survey", "assessmentSurvey"],
  ["/updatesurvey", "updateSurvey"],
  ["/updateSurvey", "updateSurvey"],
  ["/updateQuestion", "updateQuestion"],
  ["/controls", "controlCatalog"],
  ["/updateImpacted", "updateImpact"],
  ["/compliances", "compliance"],
  ["/catalogs/resources", "resources"],
  ["/catalogs/services", "servicesCatalog"],
  ["/catalogs", "catalogs"],
  ["/configuration", "configuration"],
  ["/demo-partner", "demoPartner"],
  ["/policy", "policyLibrary"],
  ["/bankQuestions", "bankQuestions"],
];

const PREFIX_APP_PAGE_DESC_KEYS: [string, string][] = [...PREFIX_APP_PAGE_DESC_KEYS_RAW].sort(
  (a, b) => b[0].length - a[0].length
);

/**
 * i18n key suffix for static page description (`pageDescriptions.<key>`).
 * Dynamic pages should use `usePageHeadingOverride` instead.
 */
export function pageDescriptionI18nKey(pathname: string): string {
  const raw = pathname.replace(/\/$/, "") || "/";

  if (EXACT_APP_PAGE_DESC_KEYS[raw]) return EXACT_APP_PAGE_DESC_KEYS[raw];

  for (const [prefix, key] of PREFIX_APP_PAGE_DESC_KEYS) {
    if (raw === prefix || raw.startsWith(`${prefix}/`)) {
      return key;
    }
  }

  return "default";
}

/** @deprecated Use breadcrumbPageLabel */
export function labelForPathname(pathname: string): string {
  return breadcrumbPageLabel(pathname);
}
